import { makeStyles } from "@material-ui/core/styles";

export const useListingTableRenderComponentsStyles = makeStyles(() => ({
  avatarWithName: {
    display: "flex",
    "align-items": "center",
    "& .MuiAvatar-root": {
      "margin-right": "15px",
    },
  },
}));
